var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 102,
    viewBox: "0 0 149 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.2006 0L0 57.3096V101.091L148.528 0H84.2006Z",
    fill: "#E07E27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9009 50.6055L46.2042 69.3072L0 101.21V57.2061L9.9009 50.6055Z",
    fill: "#FFDA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.605 30.252L75.3583 50.0538L46.2056 69.3055L9.90234 50.6038L39.605 30.252Z",
    fill: "#F58220"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.108 11.5508L82.5094 45.1038L74.8087 50.0543L39.6055 30.2525L67.108 11.5508Z",
    fill: "#D9166F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1595 0L96.8106 35.2032L82.5093 45.1041L66.0078 12.1011L84.1595 0Z",
    fill: "#50B848"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7073 0L115.509 23.1021L96.8074 35.2032L84.1562 0H95.7073Z",
    fill: "#374EA2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.859 0L132.56 11.001L113.859 24.2022L95.707 0H113.859Z",
    fill: "#DA2128"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBadge);
export default __webpack_public_path__ + "static/media/headerBadge.6b2200f8a9f79e2c2a2a3b769f058079.svg";
export { ForwardRef as ReactComponent };